import { FC } from "react";
import { sanitizeHtml } from "@1-now/booking-core";
import { usePolicyText } from "utils/usePolicyText";

/**
 * A policy as plain reading (1NOW-11174), for the desktop drawer: the tenant's sections as plain headings with
 * their paragraphs under them. It has no box, border or title of its own (the drawer has the one title), unlike
 * the checkout's Terms / Privacy / Cancellation components, which are boxes of boxes. The text is the same: the
 * operator's HTML through the same sanitizer and the same placeholders (usePolicyText).
 */
const PolicyReader: FC<{ sections: any[]; intro?: string }> = ({ sections, intro }) => {
  const { text } = usePolicyText();
  return (
    <div className="text-text-color">
      {intro && <p className="mb-6 text-sm text-text-color/70">{intro}</p>}
      {sections.length === 0 && <p className="text-sm opacity-80">This policy has no text yet.</p>}
      {sections.map((s, i) => (
        <section key={i} className="mb-7 last:mb-0">
          <h3 className="text-base font-semibold leading-snug">{s?.title}</h3>
          <div
            className="prose prose-sm ql-content mt-1.5 max-w-none break-words text-text-color [--tw-prose-body:rgb(var(--c-text-color))] [--tw-prose-bold:rgb(var(--c-text-color))] [--tw-prose-headings:rgb(var(--c-text-color))] [--tw-prose-links:rgb(var(--c-text-color))]"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(text(s?.content)) }}
          />
        </section>
      ))}
    </div>
  );
};

export default PolicyReader;
